import axios from '@/allotment/axios'

export default {
  save: data => axios.post('/company/save', data), //保存公司信息
  page: data => axios.post('/company/select/page', data), //获取公司分页数据
  approveStatus: data => axios.post('/company/update/approveStatus', data), //公司审核按钮
  status: data => axios.post('/company/update/status', data) //修改告警配置状态
}
